import PathManagement from '../../common/path-management';
import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

function HeaderCart(props) {
  const _pathManager = new PathManagement();
  const imgURL = _pathManager.getImgURL();

  const formatPrice = (priceString) => {
    if (priceString) {

        let price = parseFloat(priceString).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        return `$ ${price}`;
    }
  }

  const getArticuloUrl = (data) => {
    if (!data?.ci_promocion_beneficio_id) {
      const articuloCopete = (data?.ci_item_detalle || '').replace(/[\s,#/]+/g, '-'); // Reemplaza espacios, comas y # por guiones
      const id = data?.ci_artid != null ? String(data.ci_artid).trim() : '';
      return `/articulo/${articuloCopete}:sku=${encodeURIComponent(id)}`;
    } else {
      return null;
    }
  };

  //Devuelve el carrito que está en el header con sus rutas y estilos
  const cartItems = () => {
    if (props.cartItems && props.cartItems.products.length > 0) {
      return props.cartItems.products.map((data, i) => {
        return (
          <div className="entry" key={i} style={{paddingRight: '0'}}>
            <div className="entry-thumb">
              {/* <Link to={getArticuloUrl(data)}>
                <img src={imgURL + data.thumbnail} alt="Product" />
              </Link> */}
              {data.ci_promocion_beneficio_id ? (data.prom_imagen ? (<img src={imgURL + data.prom_imagen} id="CartImg" alt="Product" />) : (<i
                        className="icon-dollar-sign discount-icon"
                      ></i>)) : (data.ci_artid && data.thumbnail ? (
                        <Link to={getArticuloUrl(data)}>
                          <img src={imgURL + data.thumbnail} id="CartImg" alt="Product" />
                        </Link>
                      ) : (
                        <img src={imgURL + data.thumbnail} id="CartImg" alt="Product" />
                      ))}
            </div>
            <div className="entry-content" style={{paddingRight: '20px', display: 'block'}}>
              <h4 className="entry-title">
                <Link  to={getArticuloUrl(data)} className='header-cart-text'>{data.ci_item_detalle}</Link>
              </h4>
            </div>
            <div
              className="entry-delete"
              onClick={() => {
                props.deleteCartItem(data.ci_artid);
              }}
            >
              <i className="icon-x" />
            </div>
            <span className="entry-meta text-muted" style={{float: 'right'}}>
                {data.ci_cant} x {formatPrice(data.ci_precio)}
              </span>

            {/* <div className="entry-thumb">
              <Link to={getArticuloUrl(data)}>
                <img src={imgURL + data.thumbnail} alt="Product" />
              </Link>
            </div>
            <div>
              <h4 className="entry-title">
                <Link  to={getArticuloUrl(data)} className='header-cart-text'>{data.ci_item_detalle}</Link>
              </h4>
              <i className="icon-x" />
            </div>
            <div>
            <span className="entry-meta text-muted" style={{float: 'right'}}>
                {data.ci_cant} x ${data.ci_precio}
              </span>
            </div> */}
          </div>
        );
      });
    } else {
      return null;
    }
  };

  return cartItems();
}

export default HeaderCart;
